import {useIntl, FormattedMessage} from "react-intl";
import {ColorInputProps, ColorSchema} from "./types";
import Button from "@ui-components/Button";
import { PencilIcon } from "@heroicons/react/24/outline";
import {useState, useEffect} from "react";
import KColorPickerModal from "@components/Modals/KColorPickerModal";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import ColorPreviewBox from "../../../../ui-components/ColorPreviewBox";
import _ from "lodash";
import {KColorBoard} from "@feature/kcolor/types";
import {splitCode} from "@feature/kcolor/utils/utils";


export const ColorInput = ({
  color,
  setColor,
  kColorProduct,
  unselectableColors,
  inSurvey=false,
  disabled=false,
  startResearchFrom = "product",
  productCompatibleColors
}: ColorInputProps) => {

  // hooks
  const intl = useIntl();
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [isPickingColor, setIsPickingColor] = useState(false);
  const [boards, setBoards] = useState<KColorBoard[]>();

  useEffect(() => {
    // On component mount, fetch available boards
    countryApiRequest!.get("/kcolors/boards", {publicRequest:true}).then((res: any) => setBoards(res));
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`flex flex-col gap-4 ${!inSurvey?"w-full":""}`}>
      <p className="font-bold">
        <FormattedMessage
          id="select_color"
          defaultMessage={"Seleziona colore"}
        />
      </p>
      <ColorPreviewBox
        selectedColorRGB={color?.rgb}
        className={`md:w-32 sm:w-full h-20 border border-gray-400 ${!!disabled ? "opacity-50" : ""}`}
      />
      {color && <p className="font-medium">{splitCode(color.code)}</p>}
      <Button
        onClick={() => {
          if (!!disabled) return;
          setIsPickingColor(true)
        }}
        // @ts-ignore
        Icon={PencilIcon}
        className="w-full md:w-auto"
        disabled={disabled}
      >
        {intl.formatMessage({ id: "select" })}
      </Button>
      {isPickingColor && (
        <KColorPickerModal
          color={color}
          onExit={() => {
            setIsPickingColor(false);
          }}
          setColor={setColor}
          boards={boards}
          unselectableColors={_.uniq([
            ...(unselectableColors ?? []),
            ...(!!productCompatibleColors && !!boards && startResearchFrom === "product"
              ? boards
                .flatMap((b) => b.colors!.map((c:ColorSchema) => c.code))
                .filter((c) => !productCompatibleColors.includes(c))
              : []
            ),
          ])}
        />
      )}
    </div>
  );
};